import { isIOSWebKit } from "./fileUtils";

export const checkUploadAborted = (signal?: AbortSignal) => {
  if (signal?.aborted) {
    throw new DOMException("Upload canceled", "AbortError");
  }
};

export const prepareUploadBody = async (
  file: Blob,
  contentType = file.type || "application/octet-stream",
  signal?: AbortSignal
): Promise<Blob> => {
  checkUploadAborted(signal);
  if (!(file instanceof Blob) || file.size === 0) {
    throw new Error(
      "The file is empty or unavailable. Please select it again."
    );
  }
  if (!isIOSWebKit()) return file;

  // WebKit can silently send a disk-backed File/Blob as a zero-byte request.
  // Read in-page so the network process receives an in-memory Blob instead.
  // Prepare multipart video chunks individually to bound memory use.
  // https://bugs.webkit.org/show_bug.cgi?id=319985
  const bytes = await file.arrayBuffer();
  checkUploadAborted(signal);
  if (bytes.byteLength !== file.size) {
    throw new Error(
      "The file could not be fully read. Please select it again."
    );
  }
  return new Blob([bytes], { type: contentType });
};
